angular.module( 'acme.view.application.entities.detail', [
  'ui.router',
  'ui.bootstrap',
  'checklist-model',
  'acme.view.application.entities.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var entitiesDetail = {
        name: 'application.entities.detail',
        url: '/detail/:type/:id',
        views: {
          "subview-main": {
            controller: 'EntitiesDetailController',
            templateUrl: 'views/application/views/entities/detail/detail.tpl.html'
          }
        }
      };

    $stateProvider
      .state(entitiesDetail);
});
